/**
 * While the Letter/Sound hint is showing, the assessment card's global
 * keyboard shortcuts (→ ← ↑ and single letter keys, window-level keydown in
 * AssessmentForm) must not score behind the overlay. This capture-phase
 * window listener stops those keys before the page's bubble-phase handler
 * sees them; Enter, Space, Escape and Tab pass through so the hint can be
 * dismissed from the keyboard. Overlay-only: the assessment code is untouched.
 */
const SWALLOWED = new Set(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']);

export function isSwallowedKey(event) {
  if (!event || event.ctrlKey || event.metaKey || event.altKey) return false;
  if (SWALLOWED.has(event.key)) return true;
  return typeof event.key === 'string' && /^[a-zA-Z]$/.test(event.key);
}

/** @returns {() => void} remover */
export function installAssessmentKeySwallow(target = typeof window !== 'undefined' ? window : null) {
  if (!target) return () => {};
  const handler = (event) => {
    if (!isSwallowedKey(event)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  target.addEventListener('keydown', handler, true);
  return () => target.removeEventListener('keydown', handler, true);
}
